import { Button, InfoLabel, makeStyles, mergeClasses } from '@fluentui/react-components';
import { useCommonStyles } from '../common/Styles/commonStyles';
import { useSpacingUtilities } from '../../utilities/useSpacingUtilities';
import { MouseEventHandler } from 'react';

const useStyles = makeStyles({
    subtle: {
        fontWeight: 'normal'
    },
    noWrap: {
        minWidth: '0',
        maxWidth: '100%',
        overflow: 'hidden',
    },
    // InfoLabel/Label render inline by default, which stops the button from shrinking.
    wrapper: {
        display: 'flex',
        minWidth: '0',
        maxWidth: '100%',
        overflow: 'hidden',
    },
    ellipsisText: {
        display: 'block',
        minWidth: '0',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
})

type LinkButtonProps = {
    onClick?: MouseEventHandler<HTMLButtonElement>;
    icon?: JSX.Element;
    text?: string;
    tabIndex?: number;
    padding?: string;
    info?: string;
    subtle?: boolean;
};
export const LinkButton = (props: LinkButtonProps) => {
    const { onClick, icon, text, tabIndex, padding, info, subtle } = props;

    //Hooks
    const spacing = useSpacingUtilities();

    //Styles
    const commonStyles = useCommonStyles();
    const localStyles = useStyles();
    const btnClasses = mergeClasses(
        commonStyles.button.linkButton,
        localStyles.noWrap,
        !!subtle && localStyles.subtle,
        ...spacing.getSpacingClasses(padding),
    );

    return (
        <>
            <InfoLabel info={info} className={localStyles.wrapper}>
                <Button
                    className={btnClasses} size='small'
                    tabIndex={tabIndex}
                    icon={icon}
                    appearance='transparent'
                    onClick={onClick}
                    data-testid={`link-button-${text}`}
                >
                    <span className={localStyles.ellipsisText}>{text}</span>
                </Button>
            </InfoLabel>
        </>
    );
};
